import {Outlet} from 'react-router-dom';
import {Container} from 'reactstrap';
import AppNavbar from './AppNavbar';
import Footer from './Footer';
import ScrollToTop, {MAIN_CONTENT_ID} from './ScrollToTop';
import {usePageConfig} from '../../hooks/usePageConfig';

/**
 * The app shell: navbar, a scrolling content panel and the privacy footer.
 * Pages flagged fullBleed in pages.ts drop the panel padding so they can own
 * the whole width (the tree canvas, the edit shell).
 */
function Layout() {
    const page = usePageConfig();
    const contentPanelClass = page?.fullBleed
        ? 'contentPanel ft-contentPanel--bleed mx-auto'
        : 'contentPanel pt-3 pb-4 px-3 mx-auto';

    return (
        <div className="appShell">
            <ScrollToTop />
            <AppNavbar />
            <div className="mainLayoutContainer">
                <Container
                    id={MAIN_CONTENT_ID}
                    fluid
                    className={contentPanelClass}
                >
                    <Outlet />
                </Container>
            </div>
            <Footer />
        </div>
    );
}

export default Layout;
